import {DefaultTheme} from "react-native-paper";
import {darkTheme as appDarkTheme} from "../config/themes";

/**
 * Brand accents shared by both Paper themes. The orange primary and the dark
 * secondary are identical in light and dark; only the surfaces/text flip.
 */
const brand = {
  primary: "#f6821f",
  secondary: "#1F2732",
  error: "#ED1C24",
};

/**
 * Light Paper theme. Kept as the default `theme` export so the existing
 * consumers (`LoginScreen`, `components/TextInput|Button|Header|Background`,
 * `helpers/ServiceModuleFeedback`) are unchanged.
 */
export const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    text: "#2F2F2F",
    primary: brand.primary,
    secondary: brand.secondary,
    error: brand.error,
  },
};

export const lightTheme = theme;

/**
 * Dark Paper theme. Same brand accents, but surfaces/text come from the app's
 * dark palette (`config/themes.darkTheme`) so Paper-driven components render
 * legibly in dark mode instead of staying white.
 */
export const darkTheme = {
  ...DefaultTheme,
  dark: true,
  mode: "adaptive",
  colors: {
    ...DefaultTheme.colors,
    primary: brand.primary,
    secondary: brand.secondary,
    error: appDarkTheme.colors.error,
    text: appDarkTheme.colors.text,
    onSurface: appDarkTheme.colors.onSurface,
    background: appDarkTheme.colors.background,
    surface: appDarkTheme.colors.surface,
    surfaceVariant: appDarkTheme.colors.card,
    placeholder: appDarkTheme.colors.placeholder,
    backdrop: "rgba(0,0,0,0.5)",
  },
};

/**
 * Select the Paper theme for the active colour scheme.
 * @param {boolean} isDark Whether dark mode is active.
 * @returns {object} The matching Paper theme.
 */
export const getPaperTheme = (isDark) => (isDark ? darkTheme : lightTheme);
